import React from 'react';
const stats = [{
  value: '+12.000',
  label: 'Trænere og lærere i fællesskabet 🌎'
}, {
  value: '500+',
  label: 'Klubber og skoler bruger dette system'
}, {
  value: '180.000+',
  label: 'Øvelser og sessioner downloadet i år'
}, {
  value: '92%',
  label: 'Sparer 6+ timer på ugentlig planlægning'
}];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-10 sm:py-14 border-y border-border-light px-4 relative overflow-hidden" data-id="element-274">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-275"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-276">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-277">
          {stats.map((stat, i) => <div key={i} className="text-center px-2 sm:px-4 border-r border-border-light/50 last:border-r-0 even:border-r-0 lg:even:border-r lg:last:border-r-0" data-id="element-278">
              <div className="text-primary font-black text-3xl sm:text-5xl tracking-tight drop-shadow-[0_0_15px_rgba(59,130,246,0.4)] mb-2" data-id="element-279">
                {stat.value}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-tight font-medium" data-id="element-280">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-10 sm:mt-12 max-w-3xl mx-auto bg-bg-dark/50 backdrop-blur-sm border border-border-light rounded-2xl p-5 sm:p-6" data-id="element-281">
          <p className="text-text-main font-bold text-sm sm:text-base text-center mb-4 tracking-wider uppercase" data-id="element-282">
            Professionel standard
          </p>
          <ul className="space-y-2.5 sm:space-y-2 text-text-sec text-sm sm:text-base" data-id="element-283">
            <li className="flex items-start gap-2" data-id="element-284">
              <span className="text-check-green flex-shrink-0" data-id="element-285">✓</span>
              <span data-id="element-286">
                Designet ud fra moderne taktiske og pædagogiske principper.
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-287">
              <span className="text-check-green flex-shrink-0" data-id="element-288">✓</span>
              <span data-id="element-289">
                Tilpasset til niveauerne: Begynder, Udvikling og Konkurrence.
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-290">
              <span className="text-check-green flex-shrink-0" data-id="element-291">✓</span>
              <span data-id="element-292">Kompatibel med tablet, mobil, PC og klar til print.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}